import { Record } from 'immutable';
import create from './create';

const SkillRecommendationRecord = Record({
  skillId: undefined,
  skillRecommendationItems: undefined,
});
class SkillRecommendation extends SkillRecommendationRecord { }

SkillRecommendation.create = create;

export default SkillRecommendation;



// WEBPACK FOOTER //
// ./data/SkillRecommendation/model.js